import { useEffect, useId } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import {
  DEALS_BETA_DISCLAIMER_PARAGRAPHS,
  DEALS_BETA_DISCLAIMER_TITLE,
} from '../dealsBetaDisclaimer';

/**
 * First-visit gate for Deal of the Day — must accept before browsing deals.
 * @param {{ onAccept: () => void }} props
 */
export function DealsBetaDisclaimerModal({ onAccept }) {
  const titleId = useId();

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  return createPortal(
    <div
      className="deals-beta-modal__backdrop"
      role="presentation"
    >
      <div
        className="deals-beta-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="deals-beta-modal__header">
          <span className="deals-beta-modal__badge">BETA</span>
          <h2 id={titleId} className="deals-beta-modal__title">
            {DEALS_BETA_DISCLAIMER_TITLE}
          </h2>
        </div>
        <div className="deals-beta-modal__body">
          {DEALS_BETA_DISCLAIMER_PARAGRAPHS.map((paragraph) => (
            <p key={paragraph} className="deals-beta-modal__text">
              {paragraph}
            </p>
          ))}
          <div className="deals-beta-modal__actions">
            <button
              type="button"
              className="deals-beta-modal__accept"
              onClick={onAccept}
            >
              Got it — show me today&apos;s deals
            </button>
            <Link className="deals-beta-modal__back" to="/">
              Back to homepage
            </Link>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
